<template>
  <hic-dialog :title="'床位' + (value.id ? '编辑' : '新建')" :visible="visible" @open="open" @close="close" width="45rem">
    <el-form ref="form" :model="value" :rules="rules" inline label-width="6rem">
      <el-form-item label="所在病房：">
        <el-cascader v-model="site" :options="options" :props="{ expandTrigger: 'hover', value: 'code', label: 'text' }" @change="siteChange" size="small" style="width: 18rem"></el-cascader>
      </el-form-item>
      <el-form-item label="所属科室：" prop="deptCode">
        <hic-dict-selector v-if="!setting.isSimple &&!value.ipNo" dict-type="Dept" v-model="value.deptCode" class="edit-input" />
        <span v-else>{{ value.deptCode | dictText("Dept") }}</span>
      </el-form-item>
      <el-form-item label="所属病区：" prop="wardCode">
        <hic-dict-selector dict-type="IpWard" v-model="value.wardCode" />
      </el-form-item>
      <el-form-item v-if="!setting.isSimple" label="床位类型：" prop="type">
        <hic-dict-selector v-if="!value.ipNo" dict-type="BedType" v-model="value.type" />
        <span v-else>{{ value.type | dictText("BedType") }}</span>
      </el-form-item>

      <el-form-item label="床位编号：" prop="no">
        <el-input v-if="!value.ipNo" type="text" v-model="value.no" size="small" />
        <span v-else>{{ value.no }}</span>
      </el-form-item>

      <el-form-item v-if="!setting.isSimple" label="临时加床：">
        <el-switch v-model="value.ifExtra" active-text="" inactive-text="" active-color="#e6a23c"></el-switch>
      </el-form-item>
      <el-form-item label="停用：" v-if="value.id">
        <el-switch v-if="!value.ipNo" v-model="value.disabled" active-text="" inactive-text="" active-color="#ff4949"></el-switch>
        <span v-else class="right-pad danger">
          使用中：
          <span v-if="hosp" class="info">
            {{ hosp.patientName }}
            {{ hosp.patientGender | dictText("Gender") }}
            {{ hosp.patientAge }}
            {{ hosp.deptCode | dictText("Dept") }}
            {{ hosp.startDate | fmtDate }}入院
          </span>
        </span>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-popconfirm v-if="value.id && permission.admission_bed_delete" title="确定要删除床位吗？" class="pull-left" @confirm="del">
        <el-button slot="reference" type="danger" icon="el-icon-delete" :disabled="!!value.ipNo"></el-button>
      </el-popconfirm>
      <el-button type="info" @click="close">关 闭</el-button>
      <el-button type="primary" @click="save" v-loading="saving">保 存</el-button>
      <el-checkbox v-if="!value.id" v-model="autoNext" class="left-pad"><h4>连续新建</h4></el-checkbox>
    </template>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      value: Object,
      visible: Boolean,
    },
    data() {
      return {
        site: [],
        rules: {
          deptCode: [{ required: true, message: "请选择所属科室", trigger: "blur" }],
          wardCode: [{ required: true, message: "请选择所属病区", trigger: "blur" }],
          type: [{ required: true, message: "请选择床位类型", trigger: "blur" }],
          no: [{ required: true, message: "请输入床位编号", trigger: "blur" }],
        },
        autoNext: false,
        saving: false,
        hosp: null,
      };
    },
    computed: {
      ...mapGetters(["dict", "setting", "permission"]),
      options() {
        let list = [];
        list.push(...this.dict.Building);
        list.push(...this.dict.Floor);
        list.push(...this.dict.Room);
        return this.$utils.Cascade.make(list);
      },
    },
    methods: {
      open() {
        this.autoNext = false;

        this.site = [];
        if (this.value.building) {
          this.site.push(this.value.building);
        }
        if (this.value.floor) {
          this.site.push(this.value.floor);
        }
        if (this.value.room) {
          this.site.push(this.value.room);
        }
        if (this.$refs.form) {
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
        }
        this.hosp = null;

        if (this.value.ipNo) {
          api.Hospitalization.ipNo(this.value.ipNo).then((res) => {
            this.hosp = res;
          });
        }
      },
      close() {
        this.$emit("update:visible", false);
      },
      siteChange(site) {
        this.value.building = site[0];
        this.value.floor = site[1];
        this.value.room = site[2];
        if (!this.value.deptCode && this.dict.Dept.findIndex((x) => x.code == this.value.floor) > -1) {
          this.value.deptCode = this.value.floor;
        }
      },
      save() {
        if (this.saving) {
          return;
        }
        if (!this.value.room || !this.value.floor || !this.value.building) {
          this.$message.warning("请选择床位所在病房！");
          return;
        }

        this.$refs.form
          .validate()
          .then((res) => {
            if (this.value.disabled && this.value.ipNo) {
              this.$message.warning("当前床位上已安排患者，无法停用！");
              return;
            }
            if (this.setting.isSimple) {
              this.value.wardCode = this.value.floor;
            }
            this.saving = true;
            if (!this.value.type) {
              this.value.type = this.dict.BedType[0].code;
            }
            if (!this.value.wardCode) {
              this.value.wardCode = this.dict.IpWard[0].code;
            }
            api.Bed.save(this.value)
              .then((res) => {
                this.$message.success("保存成功！");
                this.$emit("saved");
                if (this.autoNext) {
                  this.value.no = null;
                  this.value.id = null;
                } else {
                  this.close();
                }
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.saving = false;
              });
          })
          .catch((err) => {});
      },
      del() {
        api.Bed.del(this.value.id)
          .then((res) => {
            this.$message.success("已删除！");
            this.$emit("saved");
            this.close();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
    },
  };
</script>
